import { createFileRoute } from "@tanstack/react-router";
import { CreditCard } from "lucide-react";
import { z } from "zod";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { PaymentReturn } from "@/features/payments/modules/payment-return/payment-return";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/payments/return/")({
  loader: () => ({ crumb: m.payment_return_crumb() }),
  validateSearch: z.object({ orderId: z.string(), cancelled: z.string().optional() }),
  component: PaymentReturnPage,
});

function PaymentReturnPage() {
  const { orderId, cancelled } = Route.useSearch();
  return (
    <PageShell icon={CreditCard} title={m.payment_return_title()}>
      <PaymentReturn orderId={orderId} cancelled={cancelled === "1"} />
    </PageShell>
  );
}
